export default __webpack_public_path__ + "static/media/0172.c9d2489f.png";